import CumulativeCarbonPolicyCostChart from "./CumulativeCarbonPolicyCostChart";

export default CumulativeCarbonPolicyCostChart;
